import React from 'react'

import { HeroHeader } from '@cash-design-system/react'
import { FormBlockerElementHeroHeaderElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'

export function HeroHeaderElement(props: FormBlockerElementHeroHeaderElement): React.ReactElement {
  const title = props.header?.title_text?.translated_value ?? ''
  const body = props.header?.body_text?.translated_value

  if (!props.header?.title_text?.translated_value) {
    logger.error(new Error('HeroHeaderElement: title_text is required but not provided, using empty string'))
  }

  return <HeroHeader title={title} titleElement="h1" body={body} />
}
